import type * as React from 'react';
import { del } from '@Domain/Api';
import identityProviderDeleted, {
	type IdentityProviderDeletedAction,
} from '@Application/Security/Sso/Actions/identityProviderDeleted';
import identityProviderDeletionFailed, {
	type IdentityProviderDeletionFailedAction,
} from '@Application/Security/Sso/Actions/identityProviderDeletionFailed';
import type DeleteIdentityProvider from '@Application/Security/Sso/Commands/DeleteIdentityProvider';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = IdentityProviderDeletedAction | IdentityProviderDeletionFailedAction;

export default (command: DeleteIdentityProvider) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(`${parameters.api.host}/api/accounts/${command.accountId}/identity-provider`);

			const action = identityProviderDeleted(command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = identityProviderDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
